.SnapLogo {
  color: var(--primary);
  display: flex;
  position: relative;
  width: 23.125rem;
  height: 7.563rem;
}

.SnapLogo--inner-wrapper {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 23.125rem;
  height: 7.563rem;
}

.SnapLogo--mainText {
  position: relative;
  font-size: 6.5rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0;
}

.SnapLogo--icon {
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 0 1rem 0 0;
}

.SnapLogo .fa-camera {
  position: relative;
  bottom: 0.6rem;
  font-size: 7.5rem;
}

.SnapLogo--camera-circle {
  position: absolute;
  top: 48%;
  left: 44%;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  background: var(--primary);
  border: 0.5rem solid var(--light);
  transform: translate(-50%, -50%);
}

.SnapLogo--subText {
  position: absolute;
  color: var(--darker-gray);
  font-size: 1rem;
  font-weight: 500;
  bottom: -1.094rem;
  right: 3.813rem;
}

.SnapLogo--beta {
  position: absolute;
  color: var(--primary);
  font-size: 1.25rem;
  font-weight: 700;
  top: 0.8rem;
  right: 0.35rem;
  text-transform: uppercase;
}

.SnapLogo__small .SnapLogo--subText {
  display: none;
}

.SnapLogo.SnapLogo__small {
  width: 10.846rem;
  height: 3.547rem;
}

.SnapLogo__small .SnapLogo--inner-wrapper {
  transform-origin: top left;
  transform: scale(0.469);
}

@media screen and (max-width: 480px) {
  .SnapLogo {
    width: 18.5rem;
    height: 6.063rem;
  }

  .SnapLogo--inner-wrapper {
    transform-origin: top left;
    transform: scale(0.8);
  }
}

@media screen and (max-width: 300px) {
  .SnapLogo {
    width: 222px;
    height: 72.6px;
  }

  .SnapLogo--inner-wrapper {
    transform-origin: top left;
    transform: scale(0.6);
  }
}
